/* Native Shopify owns email consent and eligibility. Klaviyo stores optional phone only. */
(() => {
  'use strict';
  const copy = JSON.parse(document.getElementById('sitr-copy-config')?.textContent || '{}');
  const localeRoot = window.Shopify?.routes?.root || '/';

  const pendingKey = 'sitr-ha:signup-pending:v2';
  const receiptKey = 'sitr-ha:signup-receipt:v2';
  const contactKey = 'sitr-ha:checkout-contact:v1';
  const thanksPath = localeRoot + 'pages/signup-thank-you';
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const fresh = value => value && typeof value.id === 'string' && Number.isFinite(value.created) && Date.now() >= value.created && Date.now() - value.created < 1800000;
  function normalizePhone(value) {
    let phone = value.trim().replace(/[٠-٩]/g, d => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d))).replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d))).replace(/[\s().-]/g, '');
    if (/^01[0125]\d{8}$/.test(phone)) phone = '+20' + phone.slice(1);
    else if (/^0020/.test(phone)) phone = '+' + phone.slice(2);
    else if (/^20\d{10}$/.test(phone)) phone = '+' + phone;
    return /^\+[1-9]\d{6,14}$/.test(phone) ? phone : null;
  }
  document.querySelectorAll('[data-sitr-phone]').forEach(details => {
    const form = details.closest('form');
    const phone = details.querySelector('[data-phone-input]');
    const error = details.querySelector('[data-phone-error]');
    const skip = details.querySelector('[data-phone-skip]');
    const email = form.querySelector('[name="contact[email]"]');
    let saved = '', saving = false;
    function fail(message, allowSkip = false) {
      details.open = true; error.textContent = message; error.hidden = false; skip.hidden = !allowSkip;
      phone.setAttribute('aria-invalid', 'true'); phone.focus();
    }
    phone.addEventListener('input', () => { phone.removeAttribute('aria-invalid'); error.hidden = true; skip.hidden = true; });
    skip.addEventListener('click', () => { phone.value = ''; error.hidden = true; skip.hidden = true; phone.removeAttribute('aria-invalid'); form.requestSubmit(); });
    form.addEventListener('submit', async event => {
      if (saving) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      const raw = phone.value.trim();
      const normalized = raw ? normalizePhone(raw) : '';
      if (raw && !normalized) {
        event.preventDefault(); event.stopImmediatePropagation();
        fail(copy.phone_invalid); return;
      }
      const signature = email.value.trim().toLowerCase() + '|' + normalized;
      if (normalized && saved !== signature) {
        event.preventDefault(); event.stopImmediatePropagation(); saving = true;
        const submitter = event.submitter || form.querySelector('[type="submit"]');
        const label = submitter.textContent; submitter.disabled = true; submitter.textContent = copy.saving;
        const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/profiles?company_id=UdGmjb', {
            method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' }, signal: controller.signal,
            body: JSON.stringify({ data: { type: 'profile', attributes: {
              email: email.value.trim(), phone_number: normalized,
              properties: { prelaunch_contact_phone: normalized, prelaunch_phone_source: 'optional_website_field' }
            } } })
          });
          if (response.status !== 202) throw new Error('Phone save failed');
          saved = signature; phone.value = normalized; phone.removeAttribute('aria-invalid'); error.hidden = true; skip.hidden = true;
        } catch (_) {
          fail(copy.phone_failed, true);
        } finally {
          clearTimeout(timeout); saving = false; submitter.disabled = false; submitter.textContent = label;
        }
        if (saved === signature) form.requestSubmit(submitter);
        return;
      }
      // Brief, tab-scoped checkout convenience. Never publish these values in analytics.
      const pending = { id: crypto.randomUUID(), created: Date.now(), path: location.pathname, form: form.id };
      write(pendingKey, pending);
      write(contactKey, { id: pending.id, created: pending.created, email: email.value.trim(), phone: normalized, confirmed: false });
    }, true);
  });
  document.querySelectorAll('#set-signup').forEach(el => { if (el.querySelector('[role=alert]:not([hidden]), [data-sitr-signup-confirmed]')) el.open = true; });
  const success = document.querySelector('[data-sitr-signup-confirmed]');
  if (success) {
    const pending = read(pendingKey);
    if (fresh(pending) && pending.path === location.pathname && success.closest('form')?.id === pending.form) {
      write(receiptKey, { id: pending.id, created: pending.created, reported: false });
      const contact = read(contactKey);
      if (fresh(contact) && contact.id === pending.id) { contact.confirmed = true; write(contactKey, contact); }
    }
    remove(pendingKey);
    location.replace(thanksPath);
    return;
  }
  const thanks = document.querySelector('[data-sitr-thanks]');
  if (!thanks) return;
  const receipt = read(receiptKey);
  if (!fresh(receipt)) return; // Direct visits never report a signup or claim confirmed access.
  thanks.dataset.signupConfirmed = 'true';
  thanks.querySelector('[data-thanks-heading]').textContent = copy.thanks_confirmed;
  thanks.querySelector('[data-thanks-ar]').hidden = true;
  thanks.querySelector('[data-thanks-message]').textContent = copy.signup_conditions;
  thanks.querySelector('[data-thanks-signup]').hidden = true;
  let attempts = 0;
  function publish() {
    if (receipt.reported) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed() || !privacy.analyticsProcessingAllowed()) return;
    const analytics = window.Shopify?.analytics;
    if (!analytics?.publish) { if (++attempts < 20) setTimeout(publish, 250); return; }
    // Consume before dispatch so refresh/back cannot fire the same lead again.
    receipt.reported = true; write(receiptKey, receipt);
    try {
      const result = analytics.publish('sitr_ha_lead_created', { submission_id: receipt.id, source: 'founding_access' });
      thanks.dataset.signupEvent = 'published';
      if (result?.catch) result.catch(() => { thanks.dataset.signupEvent = 'unavailable'; });
    } catch (_) { thanks.dataset.signupEvent = 'unavailable'; }
  }
  if (window.Shopify?.customerPrivacy) publish();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) publish(); });
  document.addEventListener('visitorConsentCollected', publish);
})();

